import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function QuestionSkinBudgetPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionSkinBudget.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionSkinBudget.button1'),
          value: 'simple_affordable',
        },
        {
          text: t('pages.onboarding.questionSkinBudget.button2'),
          value: 'balanced_flexible',
        },
        {
          text: t('pages.onboarding.questionSkinBudget.button3'),
          value: 'willing_invest',
        },
        {
          text: t('pages.onboarding.questionSkinBudget.button4'),
          value: 'premium_works',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
